import { render, staticRenderFns } from "./StudentstatisticsSubordinateUnitsTrackMerging.vue?vue&type=template&id=e1271b7c"
import script from "./StudentstatisticsSubordinateUnitsTrackMerging.vue?vue&type=script&lang=js"
export * from "./StudentstatisticsSubordinateUnitsTrackMerging.vue?vue&type=script&lang=js"
import style0 from "./StudentstatisticsSubordinateUnitsTrackMerging.vue?vue&type=style&index=0&id=e1271b7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports